import { render, staticRenderFns } from "./endStatement.vue?vue&type=template&id=5a979409&scoped=true&"
import script from "./endStatement.vue?vue&type=script&lang=js&"
export * from "./endStatement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a979409",
  null
  
)

export default component.exports